'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import tkns from '@lualtek/tokens/web/tokens.json';
import clsx from 'clsx';
import { forwardRef, useMemo } from 'react';
import styles from './stack.module.css';
export const Stack = forwardRef(({ as, children, className, rowGap, columnGap, inline = false, direction = 'column', wrap = false, fill = true, vAlign = 'initial', hAlign = 'initial', hPadding, vPadding, style, maxWidth, ...otherProps }, forwardedRef) => {
    const Component = as ?? 'div';
    const alignmentTemplate = (prop) => {
        if (prop.includes('start') || prop.includes('end')) {
            return `flex-${prop}`;
        }
        return prop;
    };
    const dynamicStyle = useMemo(() => {
        const getPaddingValue = (padding, direction) => {
            const [start, end] = Array.isArray(padding) ? padding : [padding, padding];
            return direction === 'horizontal'
                ? { left: start ? tkns.space[start] : 0, right: end ? tkns.space[end] : 0 }
                : { top: start ? tkns.space[start] : 0, bottom: end ? tkns.space[end] : 0 };
        };
        const vPaddingValues = vPadding ? getPaddingValue(vPadding, 'vertical') : { top: 0, bottom: 0 };
        const hPaddingValues = hPadding ? getPaddingValue(hPadding, 'horizontal') : { left: 0, right: 0 };
        return {
            '--r-gap': rowGap ? tkns.space[rowGap] : 0,
            '--c-gap': columnGap ? tkns.space[columnGap] : 0,
            '--v-align': alignmentTemplate(vAlign),
            '--h-align': alignmentTemplate(hAlign),
            '--v-padding-top': vPaddingValues.top,
            '--v-padding-bottom': vPaddingValues.bottom,
            '--h-padding-left': hPaddingValues.left,
            '--h-padding-right': hPaddingValues.right,
            '--max-width': maxWidth,
        };
    }, [columnGap, hAlign, hPadding, rowGap, vAlign, vPadding, maxWidth]);
    return (_jsx(Component, { ref: forwardedRef, style: { ...dynamicStyle, ...style }, "data-stack-inline": inline, "data-stack-wrap": wrap, "data-stack-direction": direction, "data-stack-fill": fill, "data-stack-has-padding": Boolean(hPadding ?? vPadding), className: clsx(styles.Stack, className), ...otherProps, children: children }));
});
